import React from 'react';
import { useCustomTheme } from '../../../contexts/ThemeContext';
import Chip from '@mui/material/Chip';
import CloseIcon from '@mui/icons-material/Close';
import { SvgIconProps } from '@mui/material';
import { ToolBarColor } from '../../../helpers/Themes';

interface TagProps {
    text: string;
    removable?: boolean;
    onDelete?: () => void;
    onClick?: () => void;
    searchable?: boolean;
    disabled?: boolean;
    icon?: React.ReactElement<SvgIconProps>; // ✅ new prop
    normalText?: boolean;
    blog?: boolean;
}

const Tag: React.FC<TagProps> = ({
    text,
    removable,
    onDelete,
    searchable,
    onClick,
    disabled,
    icon,
    normalText,
    blog
}) => {
    const { theme } = useCustomTheme();

    const sizedIcon = icon
        ? React.cloneElement(icon, {
              fontSize: 'small',
              sx: { fontSize: 16, ...icon.props.sx },
          })
        : undefined;

    return (
    <Chip
        sx={{
            color: theme.palette.text.secondary,
            borderRadius: '8px',
            '& .MuiChip-icon': {
                marginLeft: 1.3,
                fontSize: 16,
                ...(blog && {
                    color: theme.palette.primary.main,   // 🔵 icon becomes blue
                }),
            },
            ...(blog && {
                backgroundColor: ToolBarColor,
                fontSize: "0.75rem",
            }),
        }}
        icon={sizedIcon}
        variant="filled"
        color={!blog ? "primary" : undefined}
        label={normalText ? text : text.toUpperCase()}
        deleteIcon={removable ? <CloseIcon /> : undefined}
        onDelete={removable ? onDelete : undefined}
        onClick={searchable ? onClick : undefined}
        disabled={disabled}
    />
);
};

export default Tag;
